export default "__VITE_ASSET__ff87c827__"